import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import { DownArrow } from '@/assets'
import ImageBlock from '@/components/imageBlock'
import { MULTIPLE_AIRLINES_TXT } from '@/constants/Srp'
import { CardSummary, MetaDataType } from '@/types/srp'
import { getFormattedDate } from '@/utils/general/date'
import { getFlightLogoUrl } from '@/utils/images'
import { checkMultiAirlineCase } from '@/utils/srp/helper'

import MultiAirLineLogo from './FlightItinerary/MultiAirLineLogo'

interface FlightInfoProps {
    metaData: Partial<MetaDataType>
    summary: Partial<CardSummary>
    isOpen: boolean
    isRoundTrip: boolean
}

const FlightInfo = ({ metaData = {}, summary = {}, isOpen = false, isRoundTrip = false }: FlightInfoProps) => {
    const { airportDetail = {}, airlineDetail = {} } = metaData || {}
    const {
        firstDeparture: fromData,
        lastArrival: toData,
        flights = [],
        stops,
        totalDuration: duration
    } = summary || {}
    const { hh = 0, mm = 0 } = duration || {}
    const { code: fromCode = '', time = '' } = fromData?.airport || {}
    const { code: toCode = '' } = toData?.airport || {}
    const toCity = airportDetail[toCode]?.city || ''
    const fromCity = airportDetail[fromCode]?.city || ''
    const isMultiAirline = checkMultiAirlineCase(flights)
    const { airlineCode = '' } = flights?.[0] || {}

    const getDuration = () => {
        return `${hh}h ${mm}m (${stops ? `${stops} stop` : 'non-stop'})`
    }
    return (
        <Container
            className="py-4 px-6 flex flex-between flex-middle"
            style={{
                backgroundColor: '#FFF1EC'
            }}
        >
            <Container className="flex flex-middle">
                <Container className="flex flex-column flex-middle o-hidden" style={{ width: '84px' }}>
                    <Container className="flex">
                        {isMultiAirline ? (
                         <MultiAirLineLogo data={flights}/>
                        ) : (
                            <Container style={{ height: '32px', width: '32px' }}>
                                <ImageBlock
                                    altText={flights?.[0]?.airlineCode}
                                    customClass="br-2 o-hidden"
                                    height={32}
                                    path={getFlightLogoUrl(flights?.[0]?.airlineCode)}
                                    width={32}
                                />
                            </Container>
                        )}
                    </Container>
                    <Typography
                        className="t-truncate"
                        lineClamp={1}
                        styleConfig={{
                            css: {
                                maxWidth: '78px'
                            }
                        }}
                        variant="B4"
                    >
                        {isMultiAirline ? MULTIPLE_AIRLINES_TXT : airlineDetail[airlineCode]?.name}
                    </Typography>
                </Container>
                <Container className="ml-3">
                    <Typography variant="HM3">
                        {getFormattedDate(time, 'ddd, MMM DD', 'YYYY-MM-DDTHH:mm:ss')}
                    </Typography>
                    <Typography className="mt-1" variant="B2">
                        {`${fromCity} - ${toCity}・${getDuration()}`}
                    </Typography>
                </Container>
            </Container>
            {isRoundTrip && (
                <Container style={{ rotate: isOpen ? '0deg' : '180deg' }}>
                    <DownArrow />
                </Container>
            )}
        </Container>
    )
}

export default FlightInfo
